import { css } from 'glamor';

export const buttons = css({
  display: 'flex',
  flexDirection: 'row',
});
